const MobileDiscoveryHeading = ({ title, actions = [] }) => {
    return (
        <div className="mobile-discovery-heading">
            <h2 className="mobile-discovery-heading__title">{title}</h2>

            <div className="mobile-discovery-heading__actions">
                {actions.map((action) => (
                    <button
                        key={action.label}
                        type="button"
                        className="mobile-discovery-heading__button"
                        onClick={action.onClick}
                        aria-label={action.label}
                    >
                        <img src={action.icon} alt="" aria-hidden="true" />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default MobileDiscoveryHeading;
